var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('d-player-setting-options',{attrs:{"options":_vm.options,"valueAttr":"code","labelAttr":"name","defaultValue":_vm.subtitlesChoice},on:{"change-value":function($event){_vm.changeSubtitle($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }